import { FormGroup, FormControl, FormArray } from '@angular/forms'

import { BaseComponent, BaseWebviewPageComponent } from 'core/abstract-components'
import { APP_INJECTOR } from 'app.module'
import { ValidatorsService } from './validators.service'

export abstract class BaseWebviewFormComponent extends BaseWebviewPageComponent {
  protected form: FormGroup
  protected validators: ValidatorsService
  protected loading: boolean

  constructor() {
    super()

    this.validators = APP_INJECTOR.get(ValidatorsService)
  }

  ngOnInit() {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  protected submit(event?: any) {
    if (event) { event.preventDefault() }
    if (this.loading) { return }
    
    if (!this.form.valid) {
      this.handleInvalidForm()
    } else {
      this.sendForm()
    }
  }

  protected abstract sendForm()

  protected handleInvalidForm() {
    this.markFormTouched(this.form)
  }

  protected markFormTouched(form: FormGroup) {
    for (let key in form.controls) {
      let control = form.controls[key]
      if (control.constructor == FormControl) {
        control.markAsTouched()
      }
      else if (control.constructor == FormArray) {
        for (let arrKey in control['controls']) {
          this.markFormTouched(control['controls'][arrKey])
        }
      }
      else if (control.constructor == FormGroup) {
        this.markFormTouched(<FormGroup>control)
      }
    }
  }

  invalidControl(control: FormControl): boolean {
    return control.enabled && !control.valid && control.touched
  }

  controlRequiredError(control: FormControl): boolean {
    return this.invalidControl(control) && control.errors && control.errors.required
  }

  controlUniquenessError(control: FormControl): boolean {
    return this.invalidControl(control) && control.errors && control.errors.uniqueness
  }

  controlMinLengthError(control: FormControl): boolean {
    return this.invalidControl(control) && control.errors && control.errors.minlength
  }

  controlMinError(control: FormControl): boolean {
    return this.invalidControl(control) && control.errors && control.errors.min
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/base-webview-form.component.ts